import { useDispatch, useSelector } from 'react-redux';

import { WeekNavigator } from '..';
import { getWeekBoundaries } from '../../utils/dateUtils';
import { selectPeriod, setSelectedPeriod } from '../../redux/shifts/shiftsSlice';
import { selectCurrentVenue } from '../../redux/slices/currentUserSlice';

const formatWeekRangeTitle = ({ month, start, end, year }) => `${month} ${start}-${end}, ${year}`;

const ShiftsPageWeekNavigator = ({ onDateChange, ...otherProps }) => {
  const dispatch = useDispatch();
  const period = useSelector(selectPeriod);
  const venue = useSelector(selectCurrentVenue);
  const startOfWeekIndex = venue?.startOfWeekIndex ?? 0;

  const handleWeekChange = (newDate) => {
    const { weekStart, weekEnd } = getWeekBoundaries(newDate, startOfWeekIndex);
    const newPeriod = {
      start: weekStart.toISOString(),
      end: weekEnd.toISOString(),
    };
    dispatch(setSelectedPeriod(newPeriod));
    onDateChange?.(weekStart.toDate());
  };

  return (
    <WeekNavigator
      onWeekChange={handleWeekChange}
      selectedDate={period?.start}
      renderTitle={formatWeekRangeTitle}
      {...otherProps}
    />
  );
};

export default ShiftsPageWeekNavigator;
